import styled, { css } from 'styled-components'
import { AppColors } from 'utils/colors'

interface Props {
  color?: keyof AppColors
  fontSize?: number
  isVisible?: boolean
}

const Spinner = ({ color = 'orange', fontSize = 24, isVisible = true }: Props) => (
  <Container data-testid="spinner-loader" fontSize={fontSize} isVisible={isVisible}>
    <Core color={color} />
  </Container>
)

const Container = styled.div<{ fontSize: number; isVisible: boolean }>`
  font-size: ${(p) => p.fontSize}px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  visibility: ${(p) => (p.isVisible ? 'visible' : 'hidden')};
`

export const spinnerCss = css`
  border-top: 3px solid ${(p) => p.theme.colors.orange};
  border-right: 3px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    from {
      transform: rotate(0);
    }

    to {
      transform: rotate(359deg);
    }
  }
`

const Core = styled.span<{ color: keyof AppColors }>`
  width: 1em;
  height: 1em;
  ${spinnerCss}
`

export default Spinner
